import React, { useState } from "react";

import {
  Pagination,
  SearchOrgsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { DEFAULT_TABLE_PAGINATION } from "../constants/index";
import { OrgSearchQuery, RegionSearchOrg } from "../types/search-display";
import {
  AuOrgSearchContext,
  EuOrgSearchContext,
  OrgSearchQueryContext,
  UsOrgSearchContext,
} from "./org-search-context";

interface OrgSearchContextProps {
  children: React.ReactNode;
}

const OrgSearchContextWrapper = ({ children }: OrgSearchContextProps) => {
  const [orgSearchQueryState, setOrgSearchQueryState] =
    useState<OrgSearchQuery>({
      orgName: "",
      roleId: "",
      sortByMembers: false,
    });

  const [usRegionSearchOrgs, setUsRegionSearchOrgs] = useState<RegionSearchOrg>(
    {
      orgsSearchResp: new SearchOrgsResponse({
        roles: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: DEFAULT_TABLE_PAGINATION,
        offset: 0,
      }),
      isLoading: false,
    },
  );

  const [euRegionSearchOrgs, setEuRegionSearchOrgs] = useState<RegionSearchOrg>(
    {
      orgsSearchResp: new SearchOrgsResponse({
        roles: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: DEFAULT_TABLE_PAGINATION,
        offset: 0,
      }),
      isLoading: false,
    },
  );

  const [auRegionSearchOrgs, setAuRegionSearchOrgs] = useState<RegionSearchOrg>(
    {
      orgsSearchResp: new SearchOrgsResponse({
        roles: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: DEFAULT_TABLE_PAGINATION,
        offset: 0,
      }),
      isLoading: false,
    },
  );

  const orgSearchQueryContextValue = {
    orgSearchQueryState,
    setOrgSearchQueryState,
  };

  const usOrgSearchContextValue = {
    usRegionSearchOrgs,
    setUsRegionSearchOrgs,
  };

  const euOrgSearchContextValue = {
    euRegionSearchOrgs,
    setEuRegionSearchOrgs,
  };

  const auOrgSearchContextValue = {
    auRegionSearchOrgs,
    setAuRegionSearchOrgs,
  };

  return (
    <OrgSearchQueryContext.Provider value={orgSearchQueryContextValue}>
      <UsOrgSearchContext.Provider value={usOrgSearchContextValue}>
        <EuOrgSearchContext.Provider value={euOrgSearchContextValue}>
          <AuOrgSearchContext.Provider value={auOrgSearchContextValue}>
            {children}
          </AuOrgSearchContext.Provider>
        </EuOrgSearchContext.Provider>
      </UsOrgSearchContext.Provider>
    </OrgSearchQueryContext.Provider>
  );
};

export default OrgSearchContextWrapper;
